import React from 'react';
import { pdfjs } from 'react-pdf';

import { format, isValid } from 'date-fns';
import { ru } from 'date-fns/locale';
import jwtDecode from 'jwt-decode';

import { setPush } from '../store/actions/app';
import { ITokenData } from '../types';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const getUserStatus = (token: string) => {
  const { userData } = jwtDecode(token) as ITokenData;
  const JSONUserData = JSON.parse(userData);
  return JSONUserData.status;
};

export const getSum = (sum?: string | number, shouldApplyStyle?: boolean) => {
  const rubleSign = shouldApplyStyle ? <span>{' ₽'}</span> : ' ₽';
  if (sum) {
    return (
      <>
        {sum}
        {rubleSign}
      </>
    );
  }

  return null;
};

export const getFormatDate = (
  date: Date,
  formatDate?: string,
  isResStr?: boolean
) => {
  if (isValid(new Date(date))) {
    if (isResStr)
      return format(new Date(date), formatDate || 'dd MMM yyyy HH:mm', {
        locale: ru,
      });

    return (
      <span className="format-date">
        {format(new Date(date), formatDate || 'dd MMM yyyy', { locale: ru })}
        <span>
          {format(new Date(date), formatDate || 'HH:mm', { locale: ru })}
        </span>
      </span>
    );
  }

  return '-';
};

const getPushErrorMessage = (error: any) => {
  switch (error.response.status) {
    case 400:
      switch (error.response.data.code) {
        case 'KEY_VALIDATION_ERROR':
          return 'Ошибка валидации Ключа';
        default:
          return 'Некорректные данные в запросе';
      }
    case 403:
      return 'Недостаточно прав для выполнения операции';
    default:
      return 'Произошла ошибка на стороне сервера';
  }
};

export const showError = (error: any, thunkApi: any) => {
  thunkApi.dispatch(
    setPush({
      message: getPushErrorMessage(error),
      type: 'error',
    })
  );
};
